(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-delivery"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('sd-{{ section.id }}');
  if (!section) return;

 
// ---- Region Dropdown ----

var select = section.querySelector('.sd__select');

var tables = section.querySelectorAll('.sd__table-wrap');

function showSelectedRegion() {

  if (!select) return;

  var targetId = select.value;

  tables.forEach(function (table) {

    var isSelected = table.id === targetId;

    table.style.display = isSelected ? 'block' : 'none';

    table.classList.toggle('is-active', isSelected);

  });

}

if (select) {

  select.addEventListener('change', showSelectedRegion);

  showSelectedRegion();

}

})();


  } catch(e) { console.error(e); }
})();
})();
